import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIDiaChinh = {
  LIST_DIA_CHINH: `${BASE_API_URL_CAP_DIEN}/dia-chinh/list`,
  CREATE_DIA_CHINH: `${BASE_API_URL_CAP_DIEN}/dia-chinh/create`,
  UPDATE_DIA_CHINH: `${BASE_API_URL_CAP_DIEN}/dia-chinh/update`,
  REMOVE_DIA_CHINH: `${BASE_API_URL_CAP_DIEN}/dia-chinh/delete`,
  SYNC_DIA_CHINH: `${BASE_API_URL_CAP_DIEN}/dia-chinh/sync`,
};
